module.exports = "/fast-coin/img/coin/anim/shine_1/shine_1_014.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_1/shine_1_014.png
// module id = 2330
// module chunks = 5